import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const ControlIcon = createSvgIcon(
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
  >
    <path
      d="M4.5,9.487v10.522c0,5.812,10.198,9.085,11.5,9.479c1.302-0.395,11.5-3.672,11.5-9.479V9.487c-2.799-0.253-5-2.613-5-5.478c0-0.284,0.027-0.571,0.083-0.88c-4.506-0.822-8.66-0.822-13.166,0C9.473,3.438,9.5,3.725,9.5,4.009C9.5,6.873,7.299,9.234,4.5,9.487z"
      fill="currentColor"
      opacity="0.3"
    />
    <path
      d="M22.5,3.938c0-0.284,0.027-0.571,0.083-0.88c-4.506-0.822-8.66-0.822-13.166,0C9.473,3.367,9.5,3.654,9.5,3.938c0,2.864-2.201,5.225-5,5.478v10.522c0,5.812,10.198,9.085,11.5,9.479c1.302-0.395,11.5-3.672,11.5-9.479V9.416C24.701,9.163,22.5,6.802,22.5,3.938zM26,16H16v11.849c-3.099-0.99-10-4.003-10-7.911V16h10V3.938c1.621,0,3.3,0.128,5.01,0.38c0.161,2.998,2.218,5.501,4.99,6.328V16z"
      fill="currentColor"
    />
    <path
      d="M23,4c0-0.443,0.076-0.865,0.184-1.274C21.18,2.333,18.698,2,16,2s-5.18,0.333-7.184,0.726C8.924,3.135,9,3.557,9,4c0,2.761-2.239,5-5,5v11c0,6.627,12,10,12,10s12-3.373,12-10V9C25.239,9,23,6.761,23,4zM27,20c0,5.282-9.282,8.42-11,8.956C14.282,28.42,5,25.282,5,20V9.917C7.834,9.439,10,6.968,10,4c0-0.156-0.007-0.312-0.022-0.471C12.036,3.178,14.057,3,16,3s3.964,0.178,6.022,0.529C22.007,3.688,22,3.844,22,4c0,2.968,2.166,5.439,5,5.917V20z"
      fill="currentColor"
      opacity="0.5"
    />
  </svg>,
  'ControlIcon'
);
